/* =====================================================================
   BOHO - "la magia" (THK)
   1. sparge rose SVG in ogni sezione, di ogni pagina
   2. le fa comparire quando entrano nello schermo
   3. fa scorrere una sottolineatura a matita sulle frasi chiave
   4. inserisce le fasce di carta da parati fra le sezioni
   5. sposta "Naviga" dentro il footer
   Tutto difensivo: se un pezzo non c'e', il resto continua a funzionare.
   ===================================================================== */
(function () {
  'use strict';

  var ridotto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. ROSE SPARSE ---------- */
  // posizioni studiate: sempre ai margini, mai al centro dove c'e' il testo
  var SCHEMI = [
    { t: '6%',  l: '-2.5%', w: 132, rot: -14, op: .45, tipo: 'aperta'   },
    { t: '62%', r: '-3%',   w: 108, rot: 12,  op: .38, tipo: 'bocciolo' },
    { t: '30%', r: '1.5%',  w: 92,  rot: -8,  op: .32, tipo: 'ramo'     },
    { b: '4%',  l: '3%',    w: 86,  rot: 16,  op: .3,  tipo: 'bocciolo' },
    { t: '12%', r: '6%',    w: 120, rot: 8,   op: .4,  tipo: 'aperta'   }
  ];

  /* Dove le rose NON devono andare.
     Oltre alle gallerie prodotto (dove darebbero fastidio alle foto) ora
     sono escluse anche le griglie di prodotti: dopo la call del 19/07 la
     home mette i prodotti al centro, e un fiore dietro le schede e' il
     tipo di decorazione che distrae da quello che si deve vendere. */
  var NIENTE_ROSE = '.product-media-container, [class*="media-gallery"], [class*="product-card"], .product-grid';

  function spargi() {
    var sezioni = document.querySelectorAll('#MainContent .shopify-section, .bh-footer, main section');
    if (!sezioni.length) return;

    Array.prototype.forEach.call(sezioni, function (sez, i) {
      if (sez.querySelector(NIENTE_ROSE)) return;
      // una sezione si' e una no, cosi' non diventa un giardino
      if (i % 2 === 1) return;

      var quante = 1 + (i % 2); // 1 o 2 per sezione
      for (var k = 0; k < quante; k++) {
        var s = SCHEMI[(i + k) % SCHEMI.length];
        var el = document.createElement('span');
        el.className = 'bh-petalo bh-petalo--' + s.tipo;
        el.setAttribute('aria-hidden', 'true');
        el.style.width = s.w + 'px';
        el.style.height = s.w + 'px';
        if (s.t) el.style.top = s.t;
        if (s.b) el.style.bottom = s.b;
        if (s.l) el.style.left = s.l;
        if (s.r) el.style.right = s.r;
        el.style.setProperty('--rot', s.rot + 'deg');
        el.style.setProperty('--op', s.op);
        el.style.setProperty('--dur', (11 + (i % 5) * 1.7).toFixed(1) + 's');
        el.style.setProperty('--del', (k * 1.3).toFixed(1) + 's');
        if (getComputedStyle(sez).position === 'static') sez.style.position = 'relative';
        sez.appendChild(el);
      }
    });
  }

  /* ---------- 2. COMPARSA ALLO SCROLL ---------- */
  function osserva() {
    var petali = document.querySelectorAll('.bh-petalo');
    if (!petali.length) return;
    if (!('IntersectionObserver' in window) || ridotto) {
      Array.prototype.forEach.call(petali, function (p) { p.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (voci) {
      voci.forEach(function (v) {
        if (v.isIntersecting) { v.target.classList.add('is-in'); io.unobserve(v.target); }
      });
    }, { threshold: .08, rootMargin: '0px 0px -6% 0px' });
    Array.prototype.forEach.call(petali, function (p) { io.observe(p); });
  }

  /* ---------- 3. SOTTOLINEATURA A TURNO ---------- */
  function sottolinea() {
    var titoli = document.querySelectorAll('#MainContent h2, #MainContent h3');
    var bersagli = [];

    Array.prototype.forEach.call(titoli, function (h) {
      if (h.querySelector('.bh-sotto')) return;
      // mai dentro una scheda prodotto: li' il titolo e' il nome del capo
      if (h.closest('[class*="product-card"], .product-grid')) return;
      if (!(h.textContent || '').trim()) return;

      /* CHIESTO IN CALL: "l'effetto di sottolineatura lo metterei a tutta
         la frase".

         Prima si sottolineava solo l'ULTIMA PAROLA, e per isolarla si
         doveva tagliare a mano l'ultimo nodo di testo del titolo: da li'
         erano nati i bug di spaziatura gia' corretti una volta ("Chi e
         <em>Cristina</em>" che diventava "Chi eCristina").

         Ora si avvolge l'INTERO contenuto del titolo in un unico span.
         Niente piu' manipolazione dei nodi di testo, niente piu' spazi
         persi, e il markup interno (<br>, <em>) resta intatto perche' i
         nodi vengono spostati, non riscritti.

         La frase intera puo' occupare piu' righe: e' boho-ritocchi.css a
         mettere box-decoration-break:clone sullo span, cosi' la riga si
         disegna sotto OGNI riga e non solo sotto l'ultima. */
      var span = document.createElement('span');
      span.className = 'bh-sotto';
      while (h.firstChild) span.appendChild(h.firstChild);
      h.appendChild(span);
      bersagli.push(span);
    });

    if (!bersagli.length) return;

    /* MOVIMENTO RIDOTTO: la sottolineatura si vede, ma NON lampeggia.
       Un tratto che si accende e si spegne ogni 2 secondi e' molto piu'
       insistente di uno ogni 2,6: per chi ha chiesto meno movimento
       sarebbe la cosa piu' fastidiosa della pagina. Si accendono tutte
       una volta sola e restano ferme: nessun ciclo, nessun timer, nessun
       intermittente. L'accento grafico c'e', il movimento no. */
    if (ridotto) {
      bersagli.forEach(function (b) { b.classList.add('is-on'); });
      return;
    }

    /* IL CICLO SI FERMA QUANDO LA PAGINA NON SI VEDE.
       Prima era un setInterval senza clearInterval: girava per tutta la
       vita della pagina e a ogni giro chiamava getBoundingClientRect()
       su ogni bersaglio - che forza un ricalcolo del layout - e rimuoveva
       e riapplicava una classe su tutti. Anche con la scheda in secondo
       piano o lo schermo del telefono spento. Ora l'id viene conservato e
       il ciclo viene spento su visibilitychange e riacceso al ritorno.
       Con il passo sceso da 2600ms a 2000ms questo conta ancora di piu':
       i giri sono il 30% piu' frequenti. */
    var i = 0;
    var timer = null;

    function ciclo() {
      bersagli.forEach(function (b) { b.classList.remove('is-on'); });
      var b = bersagli[i % bersagli.length];
      // si accende solo se e' davvero sullo schermo
      var r = b.getBoundingClientRect();
      if (r.top < innerHeight && r.bottom > 0) b.classList.add('is-on');
      i++;
    }

    /* CHIESTO IN CALL: "piu' frequente, quindi ogni 2 secondi". */
    function accendi() {
      if (timer === null) timer = setInterval(ciclo, 2000);
    }

    function spegni() {
      if (timer !== null) { clearInterval(timer); timer = null; }
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) spegni(); else accendi();
    });

    if (!document.hidden) accendi();
  }

  /* ---------- 4. FASCE DI CARTA DA PARATI ---------- */
  function nastri() {
    /* Le fasce sono uno stacco fra i blocchi della HOME. Altrove (scheda
       prodotto, collezione, pagine di testo) sarebbero solo rumore. */
    var main = document.getElementById('MainContent');
    if (!main || main.getAttribute('data-template') !== 'index') return;

    /* Ancorate agli ID delle sezioni, non alla loro posizione.
       Prima erano indici fissi [2, 5, 8]: con la home rifatta dopo la call
       del 19/07 la prima fascia finiva ESATTAMENTE fra la griglia Novita' e
       quella Saldi, spezzando in due il blocco dei prodotti - proprio la
       parte che si voleva compatta.

       Attenzione al nome vero dell'elemento: nei template JSON Shopify non
       scrive "shopify-section-boho_saldi" ma
       "shopify-section-template--21232824746151__boho_saldi", e quel numero
       cambia da un tema all'altro. Ci si aggancia quindi al SUFFISSO, non
       all'id intero. */
    ['boho_saldi', 'boho_negozio'].forEach(function (nome) {
      var s = document.querySelector('[id^="shopify-section"][id$="' + nome + '"]');
      if (!s || s.dataset.bhNastro) return;
      var n = document.createElement('div');
      n.className = 'bh-nastro';
      n.setAttribute('aria-hidden', 'true');
      s.parentNode.insertBefore(n, s.nextSibling);
      s.dataset.bhNastro = '1';
    });
  }

  /* ---------- 5. "NAVIGA" DENTRO IL FOOTER ---------- */
  function compattaFooter() {
    var wrap = document.querySelector('.bh-footer__wrap');
    if (!wrap) return;
    // il blocco Naviga vive in una sezione separata sotto: lo tiriamo su
    var titoli = document.querySelectorAll('footer h2, footer h3, footer h4, footer .h6');
    var navBlocco = null;
    Array.prototype.forEach.call(titoli, function (t) {
      if (/naviga/i.test(t.textContent || '') && !t.closest('.bh-footer')) {
        navBlocco = t.closest('div, nav, section');
      }
    });
    if (!navBlocco) return;
    var col = document.createElement('div');
    col.className = 'bh-footer__naviga';
    var h = document.createElement('h4');
    h.textContent = 'Naviga';
    col.appendChild(h);
    var lista = navBlocco.querySelector('ul, ol');
    if (lista) col.appendChild(lista.cloneNode(true));
    wrap.appendChild(col);
    // nascondiamo l'originale staccato
    var sezVecchia = navBlocco.closest('.shopify-section') || navBlocco;
    sezVecchia.style.display = 'none';
  }

  function avvia() {
    try { spargi(); } catch (e) {}
    try { osserva(); } catch (e) {}
    try { nastri(); } catch (e) {}
    try { sottolinea(); } catch (e) {}
    try { compattaFooter(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }
})();
